export default {
      id: "x-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#x",
      toString: function () {
        return this.url;
      }
    }